import { render, staticRenderFns } from "./videoChaternewxbk.vue?vue&type=template&id=8055cb5c&scoped=true"
import script from "./videoChaternewxbk.vue?vue&type=script&lang=js"
export * from "./videoChaternewxbk.vue?vue&type=script&lang=js"
import style0 from "./videoChaternewxbk.vue?vue&type=style&index=0&id=8055cb5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8055cb5c",
  null
  
)

export default component.exports